
// src/api/documents.js
import axios from 'axios';
import { API_URL } from '../utils/apiConfig';

const api = axios.create({
  baseURL: API_URL,
});

// Add auth token to all requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Get all documents
export const fetchDocuments = async () => {
  return await api.get('/documents');
};

// Get a single document by ID
export const getDocumentById = async (id) => {
  return await api.get(`/documents/${id}`);
};

// Find text location and optionally create form field
export const findTextLocation = async (documentId, searchText, options = {}) => {
  const payload = {
    searchText,
    ...options
  };
  console.log('🔍 Making text search request to:', `/documents/${documentId}/text-location`);
  console.log('🔍 Payload:', payload);
  console.log('🔍 Full URL:', `${api.defaults.baseURL}/documents/${documentId}/text-location`);

  const response = await api.post(`/documents/${documentId}/text-location`, payload);
  console.log('🔍 API response status:', response.status);
  console.log('🔍 API response data:', response.data);
  return response;
};

// Inverted text-location: get text within a dragged region
export const getTextInRegion = async (documentId, region) => {
  const payload = {
    page: region.page,
    x: region.x,
    y: region.y,
    width: region.width,
    height: region.height,
    tolerance: region.tolerance ?? 3,
    options: region.options || {}
  };
  const response = await api.post(`/documents/${documentId}/text-location/inverted`, payload);
  return response;
};

// Perform BART-style AI field detection and creation
export const bartFieldDetection = async (documentId, options = {}) => {
  const payload = {
    minConfidence: 0.7,
    maxFieldsPerPage: 10,
    includeContext: true,
    prioritizeSignatures: true,
    maxTotalFields: 30,
    autoCreateFields: true,
    ...options
  };

  console.log('🧠 Making BART field detection request to:', `/documents/${documentId}/bart-field-detection`);
  console.log('🧠 Payload:', payload);

  const response = await api.post(`/documents/${documentId}/bart-field-detection`, payload);
  console.log('🧠 BART field detection response status:', response.status);
  console.log('🧠 BART field detection response data:', response.data);
  return response;
};

const documentsAPI = {
  fetchDocuments,
  getDocumentById,
  findTextLocation,
  getTextInRegion,
  bartFieldDetection
};

export default documentsAPI;